import React from 'react';
import { Sanitizer } from 'acq-components/lib/base-components/Sanitizer/Sanitizer';
import styles from 'page_modules/corporate-category/components/ReinforcementBanner/__styles__/index.scss?modules';
import { HeroBanner as TwoRoundedOneArrowRIB } from 'acq-components/lib/composite-components/HeroBanner/HeroBanner';
import { Element } from '@americanexpress/aqx-components';
import TwoRoundedOneArrowRIBStyles from 'acq-components/lib/composite-components/HeroBanner/styles/TwoRoundedOneArrowRIB.scss?modules';

const ReinforcementBanner = ({ primaryContent, secondaryContent, subTitle }) => (
  <Element className={styles.corpVACbannerWrapper}>
    <TwoRoundedOneArrowRIB
      PrimaryContentComponent={Sanitizer}
      SecondaryContentComponent={Sanitizer}
      primaryContentProps={{
        safelySetInnerHTML: primaryContent,
        Component: 'p'
      }}
      secondaryContentProps={{
        safelySetInnerHTML: secondaryContent,
        Component: 'p'
      }}
      TertiaryContentComponent={() => <div />}
      styles={TwoRoundedOneArrowRIBStyles}
      primaryContainerClassName={styles.primaryContainerHeader}
      qeId={'reinforcement-banner'}
    />
    <Element className={styles.subtitleContainer}>
      <Sanitizer
        className={styles.reinforcementBannerSubtitle}
        safelySetInnerHTML={subTitle}
      />
    </Element>
  </Element>
);

export default React.memo(ReinforcementBanner);
